import { render, staticRenderFns } from "./OthersSetting.vue?vue&type=template&id=ae47f1f6&"
import script from "./OthersSetting.vue?vue&type=script&lang=js&"
export * from "./OthersSetting.vue?vue&type=script&lang=js&"
import style0 from "./OthersSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OthersSetting.vue"
export default component.exports